import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { Contract } from '../types'
import { mapChargingContractsToContracts } from './contractMapper'
import { searchContracts } from '@/api/generated/contract-search-controller/contract-search-controller'

type SearchParams = {
  query: string
  pageNumber: number
  pageSize: number
}

type UseContractSearchResult = {
  data: Contract[] | undefined
  totalCount: number | undefined
  isFetching: boolean
  error: unknown
  isSuccess: boolean
}

export const useContractSearch = ({ query, pageNumber, pageSize }: SearchParams): UseContractSearchResult => {
  const { data, isFetching, error, isSuccess } = useQuery({
    queryKey: ['searchContracts', { query, pageNumber, pageSize }],
    queryFn: ({ signal }) => searchContracts({ query, pageNumber, pageSize }, signal),
    enabled: query.length > 0,
    // Keeps the previous page's data visible while the next page loads,
    // which also means cached results are shown immediately on back-navigation.
    placeholderData: keepPreviousData
  })

  const mappedData = data?.contracts ? mapChargingContractsToContracts(data.contracts) : undefined

  return {
    data: mappedData,
    totalCount: data?.totalCount,
    isFetching,
    error,
    isSuccess
  }
}
